import { Injectable, Inject } from '@angular/core';

import { RenderStorageService } from 'render/render-storage/render-storage.service';

import { ScrollPosition } from './render-storage-scroll-position.models';


@Injectable()
export class RenderStorageScrollPosition extends RenderStorageService {

  private readonly tempScrollPosition: Record<string, ScrollPosition> = {};
  private readonly keyName: string = 'scroll-position';

  constructor(
    @Inject('Window') private readonly window: Window
  ) {
    super();
    this.tempScrollPosition = JSON.parse(this.getItem(this.keyName) ?? '{}') as Record<string, ScrollPosition>;
  }

  public saveScroll(slug: string, active?: boolean): void {
    const position: ScrollPosition = this.getScrollPosition();
    if ((position.x || position.y)) {
      position.active = active ?? false;
      this.save(slug, position);
    }
  }

  public getScroll(slug: string): boolean | ScrollPosition {
    if (this.tempScrollPosition[slug]?.active) {
      return this.tempScrollPosition[slug];
    }
    return false;
  }

  public resetScrollPosition(slug: string): void {
    this.save(slug, { x: 0, y: 0, active: false });
  }

  public deactivate(slug: string): boolean {
    if (slug) {
      const newPosition: ScrollPosition = { ...this.tempScrollPosition[slug] };
      newPosition.active = false;
      return this.save(slug, newPosition);
    }
    return false;
  }

  public activate(slug: string): boolean {
    if (slug) {
      const newPosition: ScrollPosition = { ...this.tempScrollPosition[slug] };
      newPosition.active = true;
      return this.save(slug, newPosition);
    }
    return false;
  }

  private save(slug: string, position: ScrollPosition): boolean {
    this.tempScrollPosition[slug] = position;
    return this.insert(this.keyName, JSON.stringify(this.tempScrollPosition));
  }

  private getScrollPosition(): { x: number; y: number } {
    return {
      x: this.window.scrollX,
      y: this.window.scrollY
    };
  }

}
